export default function YoutubeShortIcon({color = '#424242', ...rest}) {
  return (
    <svg
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.6204 7.16058L10.6597 6.75991L11.8044 6.15124C12.1535 5.96838 12.4631 5.71819 12.7151 5.41513C12.9672 5.11206 13.1567 4.76209 13.2728 4.38542C13.389 4.00874 13.4294 3.6128 13.3918 3.22042C13.3542 2.82805 13.2393 2.447 13.0537 2.09924C12.6809 1.39524 12.0438 0.86813 11.2824 0.633841C10.521 0.399553 9.69776 0.477274 8.99369 0.84991L2.19435 4.45324C1.68944 4.71891 1.27067 5.12292 0.987074 5.61798C0.703475 6.11304 0.566789 6.67864 0.59302 7.24858C0.620254 7.80416 0.800706 8.34137 1.1144 8.80073C1.42809 9.26009 1.86278 9.62368 2.37035 9.85124C2.39435 9.85924 3.33169 10.2512 3.33169 10.2512L2.19435 10.8519C1.71708 11.1093 1.31831 11.4911 1.04028 11.9566C0.762251 12.4222 0.615309 12.9543 0.61502 13.4966C0.618877 14.2922 0.936699 15.0542 1.49937 15.6167C2.06204 16.1792 2.82405 16.4969 3.61969 16.5006C4.10302 16.5006 4.57769 16.3846 5.00635 16.1619L11.813 12.5579C12.3169 12.2918 12.7344 11.8876 13.0166 11.3926C13.2988 10.8976 13.434 10.3324 13.4064 9.76324C13.3781 9.20687 13.1963 8.66919 12.8812 8.2098C12.5661 7.75041 12.1292 7.38725 11.6204 7.16058ZM5.39769 10.6272V6.38324L9.40235 8.50591L5.39769 10.6272Z"
        fill={color}
      />
    </svg>
  );
}
